import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import Loader from 'react-loader-spinner';
import Middleware from '../middle-ware/Middleware';
import Basketitems from './Basketitems';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../../../custom-css/Custom.css";
import { getProducts, fetchData, getCartProducts, userlogin, updateProductQuantity, removeProduct, addPromocode, get_shipping_method, getOffers, get_user_lang } from '../../../repository';


let BASE_URL;
let cart_url;
const cookies = new Cookies();
let csrftoken = '';
let userlang = '';
let checkout_url;
let home_url;
let page_category;
let product_url;
let product = []
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'http://localhost:8001';
}else if (window.location.hostname === 'dev.cocoonsealy.net'){
    BASE_URL = 'http://dev.cocoonsealy.net';
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
}else{
    BASE_URL = 'https://cocoonbysealy.ca';
}

class Basket extends Component {
    constructor(props) {
        super(props);        
        this.state = {                                                
            // products: [],
            // product: [],
            // current_product: [],            
            num_of_products: 0,
            basket:[{
                "id": '',
                "owner": null,
                "status": "",
                "lines": "",
                "url": "",
                "total_excl_tax": "",
                "total_excl_tax_excl_discounts": "",
                "total_incl_tax": "",
                "total_incl_tax_excl_discounts": "",
                "total_tax": "0.00",
                "currency": "CAD",
                "voucher_discounts": [],
                "offer_discounts": [],
                "is_tax_known": false
            }],
            basket_lines:[],
            basket_lines_loaded: false,
            parent_category: '',            
            parent_products: [],
            parent_products_meta_data: [],
            child_products_urls: [],
            child_products: [],    
            page_loading: true,
            loading: false,  
            accordionOpen: false,     
            promo_code_error: [],
            offers: [],
            vouchers: [],
            offers_set: false, 
            userlang: '',

            products: [],
            products_detail:[],
            temp_products_detail:[],
            parent_category: '',            
            parent_products: [],            
            parent_products_meta_data: [],
            children_products: [],
            children_products_detail: [],
            product_price: [],
            product_sku: [],
            product_availability: [],
            product_options: [],
        };       
                        
    }       

    componentDidMount() {
        // this.init_login(); 
        const set_lang = window.document.getElementsByClassName("user-lang")[0];                             
        set_lang.addEventListener("click", this.set_user_language);  
        // product_url = document.getElementsByClassName('basket-container')[0].dataset.productUrl;
        cart_url = document.getElementsByClassName('basket-summary')[0].getAttribute('href');
        home_url = document.getElementsByClassName('home')[0].getAttribute('href');
        checkout_url = document.getElementsByClassName('checkout-index')[0].getAttribute('href');
        // page_category = document.getElementsByClassName('basket-container')[0].dataset.productCategory;         

        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
            csrftoken = window.document.getElementById('tracker-id').value;
        }
        this.get_cbs_language_cookie();
        this.get_offers();        
                
    }

    componentDidUpdate (prevProps,prevState) {
        if (this.state.parent_products_meta_data !== prevState.parent_products_meta_data) {
            // console.log(`Now Proceed to get child product Urls`);
            // console.log(this.state.parent_products);
            // this.getChildProductUrls();            
        }
        
        
        if ( (this.state.child_products_urls !== prevState.child_products_urls) ) {                                    
            /* Retrieve child products */                        
            // console.log(`Now Proceed to get child products`);        
            // console.log(this.state.child_products_urls);
            // this.ChildProductDetail();
            
        }

        if (this.state.child_products !== prevState.child_products) {                                    
            /* Retrieve child products */                                
            // console.log(`Now Proceed to initialize basket`);                                    
            
        }

        if (this.state.child_products !== prevState.child_products) {            
            
        }
        
        if (this.state.children_products_detail !== prevState.children_products_detail && this.state.children_products_detail.length === 15 ){
            // console.log(`Children Products Detail State`, this.state.children_products_detail)

            this.setState({
                page_loading: false,
            })            
            
            // if ( this.state.basket !== undefined && this.state.page_loading === false) {
            
            //     this.is_basket_empty()
                            
            // }            
        }

        if (this.state.page_loading !== prevState.page_loading && this.state.page_loading === false && this.state.children_products_detail.length === 15) {
            // console.log(`getting cart basket`);
            this.get_cart_basket();                
        }

        if (this.state.basket_lines !== prevState.basket_lines) {
            // console.log('loading basket lines')
            // this.setState({                 
            //     basket_lines_loaded: true
            // });
            // console.log('basket_lines', this.state.basket);
        }
        
        
    }
    
    update_product = (e) => {
        // update product in cart basket
        e.preventDefault() //

        if (parseInt(e.target.value) === 0) {
            this.remove_product(e);            
        }else{
            // console.log(`update product in basket: `, this.state.basket_lines[e.target.getAttribute("data-id")].product);
            // console.log(e.target.value)
            // const csrftoken = cookies.get('csrftoken');        
            const data = {
                'url':this.state.basket_lines[e.target.getAttribute("data-id")].url,
                'quantity': e.target.value,
                "product": this.state.basket_lines[e.target.getAttribute("data-id")].product,
                "basket": this.state.basket_lines[e.target.getAttribute("data-id")].basket,
                "stockrecord": this.state.basket_lines[e.target.getAttribute("data-id")].stockrecord
            }

            updateProductQuantity(data,csrftoken).then( (res) => {
                // console.log(`%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% update responise is %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%`, res);
                this.get_cart_basket();
                this.update_cart_items_mini_basket();
            })
        }
        
    }

    remove_product = (e) => {
        // remove basket line, success sends back 204 code 
        e.preventDefault()
        // console.log(`remvoe product in basket: `, this.state.basket_lines[e.target.getAttribute("data-id")].product);
        // const csrftoken = cookies.get('csrftoken');        
        const data = {
            'url':this.state.basket_lines[e.target.getAttribute("data-id")].url,
            // 'quantity': parseInt(this.state.basket_lines[e.target.getAttribute("data-id")].quantity) 
        }

        removeProduct(data, csrftoken).then( (res) => {
            // console.log(`***************** remove product`, res);
            if (res === "") {
                // 1. Call minibasket 
                // 2. call basket menu items                                
                this.get_cart_basket();                
                this.update_cart_items_mini_basket();
            }
        })
    }

    update_cart_items_mini_basket = () => {        
        window.basketmenuitems.get_cart_basket();
        window.Cartbasket.update_basket();        
    }

    add_promo_code = (e) => {
        // update product in cart basket
        e.preventDefault()        
        const code = document.getElementById('checkout-promo-code').value;
        let elementError = [];
        this.setState({
            promo_code_error: elementError
        })
        // console.log(`add promo code in basket: `, code);
        // const csrftoken = cookies.get('csrftoken');
        addPromocode(code,csrftoken).then( (res) => {
            // if response code is 200 voucher is successful
            // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code result: `, res);
            if (res !== undefined || res !== '') {
                if (res.vouchercode !== undefined && res.vouchercode[0] === 'This field may not be blank.') {
                    // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.vouchercode[0]);
                    elementError = elementError.concat(<li className="form__error">{res.vouchercode[0]}</li>)
                    this.setState({
                        promo_code_error: elementError
                    })
                }else if (res.non_field_errors !== undefined && res.non_field_errors[0] === 'Voucher code unknown'){  
                    // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.non_field_errors[0]);
                    res.non_field_errors[0] = 'Invalid promo code; please try again.';
                    elementError = elementError.concat(<li className="form__error">{res.non_field_errors[0]}</li>)
                    this.setState({
                        promo_code_error: elementError
                    })
                }else if (res.non_field_errors !== undefined && res.non_field_errors[0].match(/expired/g)){  
                    // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.non_field_errors[0]);                    
                    elementError = elementError.concat(<li className="form__error">{res.non_field_errors[0]}</li>)
                    this.setState({
                        promo_code_error: elementError
                    })
                }else if (res.reason !== undefined && res.reason === "Your cart does not qualify for a coupon discount"){  
                    // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.reason);                    
                    elementError = elementError.concat(<li className="form__error">{res.reason}</li>)
                    this.setState({
                        promo_code_error: elementError
                    })
                }else{
                    this.setState({
                        promo_code_error: elementError
                    })                    
                    this.get_cart_basket();

                }
            }
        })
    }

    getChildProductUrls = () => {
        
        const urls = this.state.parent_products;                          
        let results = [];
        let childUrls = [];        
        for (let [key, pvalue] of Object.entries(urls)) {            
            results[key] = fetchData( pvalue.url )            
        }        

        axios.all(results)
            .then(axios.spread(function (resultsA, resultsB) {
                // Both requests are now complete
                // console.log(`Processing Child Urls`);                
                // console.log(resultsA);                
                // console.log(resultsB);
                
                let item_categoryB;
                let item_categoryA;

                if (resultsA.title === 'Essential Medium') {
                    item_categoryA = 'cocoon-essential';
                } 

                if (resultsB.title === 'Cocoon Classic') {
                    item_categoryB = 'cocoon-classic';
                }

                for (let [key, value] of Object.entries(resultsA.children)) {                    
                    // console.log(`${key}: ${value}`);                    
                    childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsA.id, 'category':item_categoryA});                    
                }

                for (let [key, value] of Object.entries(resultsB.children)) {                    
                    // console.log(`${key}: ${value}`);                    
                    childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsB.id, 'category':item_categoryB});                                                            
                }                
                
                // return childUrls;                
                                
            }))

            .then( (data) =>{                
                this.setState({
                    child_products_urls: childUrls
                });
            })
                
    }

    ChildProductDetail = () => {
        let i=0;        
        let category = "";
        let parent_id = "";        
        let products = [];
        let product;
        let buildData = [];
        let mattress_size;
        let child_products = [];
        let mattress_comfort;
        let results = [];        
        const urls = this.state.child_products_urls;        

        for (let [key, pvalue] of Object.entries(urls)) {            
            results[key] = fetchData( pvalue.url )            
        }

        axios.all(results)
            .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {                
                // console.log(`Processing Child Products`);                
                products = products.concat(results_1);                
                products = products.concat(results_2);
                products = products.concat(results_3);
                products = products.concat(results_4);
                products = products.concat(results_5);
                products = products.concat(results_6);
                products = products.concat(results_7);
                products = products.concat(results_8);
                products = products.concat(results_9);
                products = products.concat(results_10);
                products = products.concat(results_11);
                products = products.concat(results_12);
                products = products.concat(results_13);
                products = products.concat(results_14);
                products = products.concat(results_15);  
                
                return products;
            
            }))

            .then( (data) => {                                    
                let misc_urls = []            
                for (let [key, value] of Object.entries(data) ) {                                                           

                    product = {                        
                        sku_url: value.stockrecords,                        
                        price_url: value.price,                        
                        availability_url: value.availability,                                                                                    
                    }                    
                    misc_urls = misc_urls.concat(product);                    
                }                

                return misc_urls;
            })

            .then( (data) =>{  
                // update sku urls
                // console.log(`Updating Sku's, Prices, and Stock Availability`);
                // console.log(data);
                let Sresults;             
                let Aresults;
                let Presults;
                let stockrecords = [];
                let prices = [];
                let availability = [];
                
                const stockrecordsRes = this.fetch_stock_records(data);
                const pricesRes = this.fetch_product_price(data);
                const availabilityRes = this.fetch_product_availability(data);

                axios.all(stockrecordsRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {
                        
                        // console.log(`Stock Records`);
                        stockrecords = stockrecords.concat(results_1);                
                        stockrecords = stockrecords.concat(results_2);
                        stockrecords = stockrecords.concat(results_3);
                        stockrecords = stockrecords.concat(results_4);
                        stockrecords = stockrecords.concat(results_5);
                        stockrecords = stockrecords.concat(results_6);
                        stockrecords = stockrecords.concat(results_7);
                        stockrecords = stockrecords.concat(results_8);
                        stockrecords = stockrecords.concat(results_9);
                        stockrecords = stockrecords.concat(results_10);
                        stockrecords = stockrecords.concat(results_11);
                        stockrecords = stockrecords.concat(results_12);
                        stockrecords = stockrecords.concat(results_13);
                        stockrecords = stockrecords.concat(results_14);
                        stockrecords = stockrecords.concat(results_15);
                        data = data.concat(stockrecords);
                        return data;
                    }))
                    
                    
                axios.all(pricesRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {
                        
                        // console.log(`Product Prices`);
                        prices = prices.concat(results_1);                
                        prices = prices.concat(results_2);
                        prices = prices.concat(results_3);
                        prices = prices.concat(results_4);
                        prices = prices.concat(results_5);
                        prices = prices.concat(results_6);
                        prices = prices.concat(results_7);
                        prices = prices.concat(results_8);
                        prices = prices.concat(results_9);
                        prices = prices.concat(results_10);
                        prices = prices.concat(results_11);
                        prices = prices.concat(results_12);
                        prices = prices.concat(results_13);
                        prices = prices.concat(results_14);
                        prices = prices.concat(results_15);

                        data = data.concat(prices);
                        return data;
                    }))
                    

                axios.all(availabilityRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {
                        
                        // console.log(`Product Availability`);
                        availability = availability.concat(results_1);                
                        availability = availability.concat(results_2);
                        availability = availability.concat(results_3);
                        availability = availability.concat(results_4);
                        availability = availability.concat(results_5);
                        availability = availability.concat(results_6);
                        availability = availability.concat(results_7);
                        availability = availability.concat(results_8);
                        availability = availability.concat(results_9);
                        availability = availability.concat(results_10);
                        availability = availability.concat(results_11);
                        availability = availability.concat(results_12);
                        availability = availability.concat(results_13);
                        availability = availability.concat(results_14);
                        availability = availability.concat(results_15);

                        data = data.concat(availability);
                        return data;
                    }))
                    
                    .then( (data_availability) => {
                        // console.log(`Availability`);
                        // console.log(data_availability);                        

                        // for (let [key, pvalue] of Object.entries(data) ) {            
                            
                        //     data[key].availability = data_availability[key];
                        // }  
                        const stockrecords = data.filter(item => item.partner_sku, item => item.price_currency);                      
                        const prices = data.filter(item => item.incl_tax, item => item.currency);
                        const availability = data.filter(item => item.is_available_to_buy);
                        let misc_data = []
                        misc_data = misc_data.concat(stockrecords);
                        misc_data = misc_data.concat(prices);
                        misc_data = misc_data.concat(availability);
                        
                        // data = data_availability;
                        return misc_data;
                    })
                    
                    .then( (data) => {
                        axios.all(results)
                            .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {                                                

                                data = data.concat(products);
                                
                                return data;
                            }))                            

                            .then( (data) => {
                                const stockrecords = data.filter(item => item.partner_sku, item => item.price_currency);                      
                                const prices = data.filter(item => item.incl_tax, item => item.currency);
                                const availability = data.filter(item => item.is_available_to_buy);
                                const products = data.filter(item => item.title);
                                let products_essential = [];
                                let products_classic = [];
                                

                                for (let [key, value] of Object.entries(products) ) {            
                                    // console.log(`${key}: ${value}`);
                                    if ( value.title.includes("Classic") ) {
                                        products_classic = products_classic.concat(value);
                                    }else if ( value.title.includes("Essential") ) {
                                        products_essential = products_essential.concat(value);
                                    }

                                    product = {
                                        id: value.id,
                                        url: value.url,
                                        title: value.title,
                                        category: urls[key].category,
                                        parent_id: urls[key].parent_id,
                                        recommended_products: value.recommended_products,
                                        options: value.options,
                                        upc: value.upc,
                                        sku: stockrecords[key].partner_sku,
                                        sku_url: value.stockrecords,
                                        price: prices[key],
                                        price_url: value.price,
                                        availability: availability,
                                        availability_url: value.availability,
                                        size: this.match_mattress_size(value.title),
                                        comfort: this.match_mattress_comfort(value.title),                                                                                                  
                                    }
                                    
                                    child_products = child_products.concat(product);
                                }                                   
                                

                                return child_products;

                            })

                            .then( (data) =>{                                                                        
                                
                                // console.log(subtotal)
                                this.setState({                                    
                                    child_products: data,                                    
                                })
                                                
                            })

                    })                     
                                                                                                    
            })            
                    
       
    }  

    fetch_stock_records = (data) => {
        let Sresults = [];
        for (let [key, value] of Object.entries(data)) {              
            Sresults[key] = fetchData( value.sku_url );
        }
        return Sresults;
    }

    fetch_product_price = (data) => {
        let Presults = [];;
        for (let [key, value] of Object.entries(data)) {                        
            Presults[key] = fetchData( value.price_url );
        }        
        return Presults;
    }

    fetch_product_availability = (data) => {
        let Aresults = [];
        for (let [key, value] of Object.entries(data)) {  
            // console.log(`${key}: ${Svalue.sku_url}`);          
            Aresults[key] = fetchData( value.availability_url );
        }
        return Aresults;
    }

    get_cart_basket = () => {                    
        
        getCartProducts().then( (data) => {
            this.setState({
                basket:data
            }, () => {
                // console.log(`New State `, this.state)
                // this.get_voucher_savings(this.state);
                // this.get_offer_savings(this.state);
            })

            return data
        })
        .then( (data) => {
            // console.log(`---------------------------- getting cart Basket ----------------------------------`, data)                        
            this.get_basket_lines(data.lines);                  
        })
    }
    
    get_basket_lines = (url) => {  
        // console.log(`+++++++++++==================+===++==++ Get Basket Basket Lines ++========++++++++=+======+===`, url); 
        // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket ++========++++++++=+======+===`, this.state.basket);                     
        let products = []        
        fetchData(url).then( (res) => {                        
            // console.log('loading basket')
            let items = 0;
            for (let [key, pvalue] of Object.entries(res)) {     
                items = items + pvalue.quantity;
            }

            this.setState({ 
                num_of_products: items,
                basket_lines: res,
                basket_lines_loaded: true
            });
            // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Lines ++========++++++++=+======+===`, this.state.basket_lines);       
        })

        // .then( (data) => {
        //     // Fetch all product information and set to state                         
        //     let products_data = [];
        //     let i=0;
        //     for ( let [key, value] of Object.entries(data) ){            
        //         // console.log(`${key}: ${value.product}`);
        //         i =i+1;
        //         fetchData(value.product).then( (res) => {
        //             // console.log(`+++++++++++==================+===++==++ Basket fetched Data ++========++++++++=+======+===`, res);
        //             // products_data = products.concat(res);
        //             return res;
        //         })
                
        //         .then( (products_data) => {
        //             // console.log(`+++++++++++==================+===++==++ Basket Incoming Data 1 ++========++++++++=+======+===`, products_data);
        //             let current_products = this.state.products;
        //             const new_products = current_products.concat(products_data);
        //             this.setState({
        //                 products: new_products
        //             }, () => {
        //                 // console.log(`+++++++++++==================+===++==++ Basket New Products Data State ${key} ++========++++++++=+======+===`, this.state.products);
        //             })
        //         }) 

        //     }                  
        // })        

        // .then( () => {
        //     if(this.state.products.length > 0) {
        //         console.log(`+++++++++++==================+===++==++ Basket Basket Lines ++========++++++++=+======+===`, url); 
        //         console.log(`+++++++++++==================+===++==++ Basket New Products Data State Final ++========++++++++=+======+===`, this.state.child_products);
        //     }
                
                
        // })
        
    }        

    get_product_url = (url) => {        
        // console.log(`Product URL (Basket Page)`, url)
        let product_url;
        const title = this.get_product_title(url) ;               

        if (title.match(/Cocoon Classic/g)) {
            product_url = '/mattress/classic/purchase/';
        } else if (title.match(/Cocoon Essential/g)) { 
            product_url = '/mattress/essential/purchase/';
        } else if (title.match(/Sealy Premium/g)) {
            product_url = '/pillows/premium-pillow/';
        } else if (title.match(/Sealy Performance/g)) {
            product_url = '/pillows/performance-pillow/';
        } else if (title.match(/Sealy Essential/g)) {
            product_url = '/pillows/essentials-pillow/';
        }

        return product_url;
    }   
    

    get_product_category = (url) => {
        // console.log(`Product Category URL (Basket Page)`, url);
        let product_category;    
        const title = this.get_product_title(url);        

        if (title.match(/Cocoon Classic/g)) {
            product_category = 'cocoon-classic';
        } else if (title.match(/Essential Medium/g)) { 
            product_category = 'cocoon-essential';
        } else if (title.match(/Sealy Premium/g)) {
            product_category = 'sealy-premium';
        } else if (title.match(/Sealy Performance/g)) {
            product_category = 'sealy-performance';
        } else if (title.match(/Sealy Essential/g)) {
            product_category = 'sealy-essential';
        }

        return product_category;
    }    

    get_product_title = (url) => {
        // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product Url ++========++++++++=+======+===`, url);
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket ++========++++++++=+======+===`, this.state);

        let title = '';
        let product = this.state.products;    
        let child_products = this.state.children_products_detail;
        // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Products ++========++++++++=+======+===`, product);
        // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Child Products ++========++++++++=+======+===`, child_products);
        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            // title = window.Basket.get_product_title(url)
            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
            product = product.filter(item => item.url === url);
            // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 1 ++========++++++++=+======+===`, product);
            if (product === undefined || product.length === 0) {
                product = child_products.filter(item => item.url === url);
            }
            // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 2 ++========++++++++=+======+===`, product);
            title = product[0].title;
        }else{                            
            // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
            product = product.filter(item => item.url === url);
            // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 3 ++========++++++++=+======+===`, product);
            if (product === undefined  || product.length === 0) {
                product = child_products.filter(item => item.url === url);
            }

            // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 4 ++========++++++++=+======+===`, product);
            
            title = product[0].title;
        }
        // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product Title ++========++++++++=+======+===`, title);
        return title;
    }     

    match_mattress_size = (title) => {
        let mattress_size = "";        

        if (title.match(/King/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "King";                    
        }else if (title.match(/Queen/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Queen";
        }else if (title.match(/Full/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Full";
        }else if (title.match(/Twin/g) && !title.match(/XL/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin";
        }else if (title.match(/XL/g) && title.match(/Twin/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin XL";
        }
        return mattress_size;
        
    }

    match_mattress_comfort = (title) => {
        let comfort = "";
        if (title.match(/Soft/g)) {
            // alert("FUCK YEAH Soft Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Soft";
        }else if (title.match(/Firm/g)) {
            // alert("FUCK YEAH Firm Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Firm";
        }else if (title.match(/Medium/g)) {
            // alert("FUCK YEAH Medium Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Medium";
        }

        return comfort;
        
    }    

    init_login = () => {
        // const csrftoken = cookies.get('csrftoken');
        const username = 'gruvcoc';
        const password = 'silverroad32';
        userlogin(username, password, csrftoken).then( (data) => {
            // console.log(`User login: `, data);
        })
        // console.log(`++++++++++++++++++++++++++++++++++++++++++++++++++++++ STATE _________________++++++++++++++++++++++++++++++++++++++++++++++++++++++`, this.state);
    }

    

    show_savings = (e) => {
        e.preventDefault();
        e.target.classList.toggle("accordion--is-active");       
        // console.log(e.target.getAttribute('data-id'))         
        let elements = document.querySelectorAll('[data-id=b'  + e.target.getAttribute('data-id') + ']');

        // console.log(elements)
            
        for (let element of elements) {
            
            element.classList.toggle('accordion-target--is-active');
        }
    }

    display_offer_content = (quantity, index, data) => {
        let offer;
        if (data.type === 1) {            
                offer = 
                    <div
                        className="basket-line-savings__details accordion-target accordionTarget" data-id={'b' + index} onClick={this.show_savings}>
                        <div className="basket-line-savings__detail">
                            <div
                                className="basket-line-savings__title basket-line-savings__detail-title">
                                {data.savingsName}</div>
                            <div
                                className="basket-line-savings__total basket-line-savings__detail-total">
                                -${ (parseFloat( this.state.basket_lines[index].price_excl_tax_excl_discounts) - parseFloat(this.state.basket_lines[index].price_excl_tax)) }</div>
                        </div>
                    </div>
                
            
            return offer;
        } else {            
                offer =
                    <div
                        className="basket-line-savings__details accordion-target accordionTarget" data-id={'b' + index} onClick={this.show_savings}>
                        <div className="basket-line-savings__detail">
                            <div
                                className="basket-line-savings__title basket-line-savings__detail-title">
                                {data.savingsName}</div>
                            <div
                                className="basket-line-savings__total basket-line-savings__detail-total">
                                -${ (parseFloat( this.state.basket_lines[index].price_excl_tax_excl_discounts) - parseFloat(this.state.basket_lines[index].price_excl_tax)) }</div>
                        </div>
                    </div>
                
            
            return offer;
        }   
                
    }

    discount_type = (amount) => {
        let type;
        let savings = this.state.basket.offer_discounts;
        let discountName;
        // console.log(`$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ Amount $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$`, amount.toFixed(2));        
        savings = savings.filter(item => parseFloat(item.amount).toFixed(2) === amount.toFixed(2) );

        if (savings.length > 0) {
            
            // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings Initial Offer @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
            type = 1;
            discountName = savings[0].name;
            // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
            return {'type': type, 'savingsName': discountName, 'savings': savings};
        }else if (this.state.basket.voucher_discounts.length > 0) {
            savings = this.state.basket.voucher_discounts;
            // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings Initial Coupon @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
            savings = savings.filter(item => parseFloat(item.amount).toFixed(2)  === amount.toFixed(2) );
            type = 2;
            discountName = savings[0].voucher.name;
            // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
            return {'type': type, 'savingsName': discountName, 'savings': savings};
        }else {
            return {'type': 0, 'savingsName': '', 'savings': 0};
        }               
        
    }


    get_discount_type = () => {
        
    }

    get_offer_savings = () => {        
        // console.log(`Basket State`, this.state)        
        if (this.state.basket.offer_discounts !== undefined && this.state.basket.offer_discounts.length === 0) {
            return "";
        }else{
            // console.log(`get_offer_savings `, this.state)
            if (this.state.basket.offer_discounts !== undefined && this.state.basket.offer_discounts.length > 0){
                const element = document.getElementById('offner-name');
                element.innerHTML = this.state.basket.offer_discounts[0].name;
            }else{
                return "";
            }
        }
    }

    get_voucher_savings = () => {        
        // console.log(`Basket State`, this.state)        
        if (this.state.basket.voucher_discounts !== undefined && this.state.basket.voucher_discounts.length === 0 ) {
            return "";
        }else{
            // return this.basket.voucher_discounts[0].voucher.name;
            // console.log(`get_voucher_savings `, this.state)
            if (this.state.basket.voucher_discounts !== undefined && this.state.basket.voucher_discounts.length > 0){
                const element = document.getElementById('voucher-name');
                element.innerHTML = this.state.basket.voucher_discounts[0].voucher.name;
            }else{
                return "";
            }
        }
    }

    // get active discount offers  & vouchers i.e coupons
    get_offers = () => {                    
        if (this.state.offers_set === false) {
            getOffers().then( (data) => {
                this.setState({
                    offers: data.offers,
                    vouchers: data.vouchers,
                    offers_set: true
                })
            })  
        }              
    }

    get_cbs_language_cookie = () => {
        get_user_lang().then( (data) => {
            // console.log('User language is ... ',data);
            if (data.userlang !== undefined) {
                userlang = data.userlang;
                this.setState({
                    userlang
                });
            }
        })  
    }

    is_basket_empty = () => {
        // console.log(`Basket Is Not Empty`)
    }

    get_shipping_method = () => {
        const method = {
            code: 'standard',                       
        }

        get_shipping_method(method)

        .then( (data) => {
            // console.log(`Shipping Mehods set to`, data);            
        })
    }

    set_user_language = (e) => {
        e.preventDefault();        
        const form = window.document.getElementById('userlang');
        form.submit();        
    }    

    /* // initializing product data */

    init_products_details_temp = (products_detail) => {
        // console.log(`Sent in products detail`, products_detail);
        this.setState({
            temp_products_detail: this.state.temp_products_detail.concat(products_detail)
        });                
    }

    init_products_details = (products_detail) => {
        // console.log(`Minibasket Finalizing products detail`, products_detail);        
        this.setState({
            products_detail
        });
    }

    init_products = (products) =>{        
        this.setState({
            products
        });
    }

    init_product_meta = (metadata) => {        
        // console.log(`Minibasket product metadata`, metadata);        
        this.setState({
            parent_products_meta_data: metadata
        });
    }

    set_product_sku = (product_sku, product_id) => {
        const data = {sku: product_sku, id: product_id}
        this.setState({
            product_sku: this.state.product_sku.concat(data)
        });
    };

    set_product_price = (product_price, product_id) => {
        // console.log(`Product Price: `, product_price);
        const data = {price: product_price, id: product_id}
        this.setState({
            product_price: this.state.product_price.concat(data)
        });
    };

    set_product_availability = (product_availability, product_id) => {
        const data = {availability: product_availability, id: product_id}
        this.setState({
            product_availability: this.state.product_availability.concat(data)
        });
    };      
    
    set_child_products = (children_products) => {
        // console.log(`Current Children Products ${this.state.children_products.length}`, this.state.children_products);
        this.setState({
            children_products: this.state.children_products.concat(children_products)
        });
    }

    set_child_products_detail = (children_products_detail) => {
        // console.log(`Setting child products detail`, children_products_detail);
        this.setState({
            children_products_detail: this.state.children_products_detail.concat(children_products_detail)            
        });
    }    

    set_product_options = (options) => {
        this.setState({
            product_options: this.state.product_options.concat(options)
        });        
    }

    render(){
        
        return(            
            <React.Fragment>
                <Basketitems 
                    basketLoaded={this.state.basket_lines_loaded}
                    numProducts = {this.state.num_of_products}
                    userlang={this.state.userlang}
                    promo_code_error={this.state.promo_code_error}
                    add_promo_code={this.add_promo_code}
                    basket={this.state.basket}
                    remove_product={this.remove_product}
                    basket_lines={this.state.basket_lines}
                    update_product={this.update_product}
                    show_savings={this.show_savings}
                    update_product={this.update_product}
                    page_loading={this.state.page_loading}
                    checkout_url={checkout_url}
                    home_url={home_url}
                    get_product_category={this.get_product_category}
                    get_product_url={this.get_product_url}                
                    get_product_title={this.get_product_title}
                    set_current_product_title={this.set_current_product_title}
                    current_product_title={this.state.current_product_title}

                    init_products={this.init_products}
                    products={this.state.products}           
                    product_options={this.state.product_options}        
                    init_products_details_temp={this.init_products_details_temp}  
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    children_products_detail={this.state.children_products_detail}
                    children_products={this.state.children_products}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}                    
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}                    
                    parent_products_meta_data={this.state.parent_products_meta_data}                                 
                />
            </React.Fragment>
        );
    }
}


function svg_suggestions (props) {
    return (        
        <React.Fragment>
        <svg
            version="1.1" 
            id="Layer_2" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="feel-scale-circles__item"
        >
            <use href="#icon-circle"></use>
            <title>Tempur Icon</title>
        </svg>        
        <svg
            version="1.1" 
            id="Layer_3" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="feel-scale-circles__item feel-scale-circles__item--filled"
        >
            <use href="#icon-circle"></use>
            <title>Tempur Icon</title>
        </svg>
        </React.Fragment>
    );
}

function svg_question_mark (props) {
    return(
        <svg
            version="1.1" 
            id="Layer_4" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="basket-savings__title-icon"
        >
            <use href="#icon-question-mark-circle"></use>
            <title>Tempur Icon</title>
        </svg>
    )
}

export default Basket;